/**
 * Created by JackCui on 2021/12/1
 */

export const groupSchemaHandle = {
  handle (node, {mainField}) {
    if (node.__targetType === 'fieldGroup_type_summary' && !node.slots) {
      node.viewComponentName = 'summary-render'
      if (!node.props) {
        node.props = {}
      }
      node.props.name = node.name
      node.mainField = mainField
    }
    return node
  }
}

export const groupProps = {
  // title
  name: String,
  // 隐藏header
  hideHeader: {
    type: Boolean,
    default: false
  },
  // 是否可展开收起 (展开收起按钮的显示隐藏)
  fold: {
    type: Boolean,
    default: true
  },
  // 展开收起状态 v-model
  isAction: {
    type: Boolean,
    default: true
  },
  // 阴影是否显示
  shadow: {
    type: Boolean,
    default: true
  },
  // 是否需要边框 (tab下分组不会有间距)
  borderStyle: {
    type: Object,
    default () {
      return {}
    }
  }
}

// event
// 展开收起的事件
